// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_profile_profile_module_ts":"63f47bb8bfd87b09","src_app_orders_orders_module_ts":"e29c5a59d2c692f6","src_app_meetings_meetings_module_ts":"013d5af2e04b5642"}[chunkId] + ".js";
};